import React, { Component } from 'react';
import BackDraw from '../BackDraw/BackDraw';
import classes from './Modal.css';

class Modal extends Component {
    render() {
        return (
            <div className={[classes.Modal, this.props.CloseToggl ? classes.animation : null].join(" ")}>
                {this.props.children}
                <BackDraw  click = {this.props.click}/>
            </div>
        )
    }
}

export default Modal